// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .WishListIcon-iconContainer-MH0Tl {
	position: absolute;
    right: 26px;
    top: 30px;
	z-index: 2;
    cursor: pointer;
}

.WishListIcon-displayFlex-Q2EaW {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.WishListIcon-marginRight-Uxt5G {
    margin-right: 30px;
}

.WishListIcon-minWidth-WFfnL{
    min-width: 91px;
}`, "",{"version":3,"sources":["webpack://./src/components/WishListIcon/WishListIcon.css"],"names":[],"mappings":"CAAC;CACA,kBAAkB;IACf,WAAW;IACX,SAAS;CACZ,UAAU;IACP,eAAe;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;IACV,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AACA;IACI,eAAe;AACnB","sourcesContent":[" .iconContainer {\n\tposition: absolute;\n    right: 26px;\n    top: 30px;\n\tz-index: 2;\n    cursor: pointer;\n}\n\n.displayFlex {\n\tdisplay: flex;\n    align-items: center;\n}\n\n.marginRight {\n    margin-right: 30px;\n}\n.minWidth{\n    min-width: 91px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `WishListIcon-iconContainer-MH0Tl`,
	"displayFlex": `WishListIcon-displayFlex-Q2EaW`,
	"marginRight": `WishListIcon-marginRight-Uxt5G`,
	"minWidth": `WishListIcon-minWidth-WFfnL`
};
module.exports = ___CSS_LOADER_EXPORT___;
